<template>
  <div class="thousand_layout" v-loading="loading">
    <div v-if="!isGifts">
      <div class="right_box">
        <div class="flex_layout_between">
          <h3>{{$t('base.Promotions')}}</h3>
          <div class="gifts" @click="changeGifts(true)">{{$t('base.PromotionOrders')}}</div>
        </div>
      </div>
      <div>
        <div class="searchList">
          <div class="slide_box" v-for="(item,index) in activityList" :key="index" @click="goto(item)">
            <div class="like_box" :class="item.Status!=1?'sold':''">
              <div class="finished" v-if="item.Status==2"></div>
              <div class="comingSoon" v-if="item.Status==0"></div>
              <el-image class="like_img" :src="item.Imgs[0]" fit="contain" lazy></el-image>
            </div>
            <div class="slide_text">
              <p class="line_txt2">{{item.Name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isGifts">
      <div class="right_box">
        <div class="flex_layout_between">
          <el-button type="" class="base" @click="changeGifts(false)">{{$t('base.back')}}</el-button>
        </div>
      </div>
      <div>
        <ul class="giftList">
          <li v-for="(item,index) in orderList" :key="index">
            <div class="like_box">
              <el-image class="like_img" :src="item.ActivityCommodityDetail.Imgs[0]" fit="contain" lazy></el-image>
            </div>
            <div class="giftDetail">
              <div class="">
                <p class="line_txt2">{{item.ActivityCommodityDetail.Name}}</p>
              </div>
              <div class="giftCode">
                <p class="" v-if="item.ActivityCommodityDetail.CommodityType==0&&item.OrderStatus==1">{{item.LogisticsCompanyName}} : {{item.LogisticsCode}}<span @click="CopyLink(item.LogisticsCode)"></span></p>
                <p class="" v-if="item.ActivityCommodityDetail.CommodityType==1" v-for="(res,j) in item.LotteryList">Raffle Code : {{res.RedemptionCode}}<span @click="CopyLink(res.RedemptionCode)"></span></p>
              </div>
            </div>
            <div class="operate">
              <span class="color_greed" v-if="item.OrderStatus==1">{{$t('base.Released')}}</span>
              <span class="text_orange" v-if="item.OrderStatus==2">{{$t('base.Unreleased')}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="noData" v-if="resultTpye"></div>
    <list-pagination class="pagination" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!resultTpye" />
  </div>
</template>
<script>
import ListPagination from '@/components/listpagination'
export default {
  name: 'tabslist',
  components: { ListPagination },
  data() {
    return {
      isCopy: false,
      activityList: null,
      orderList: null,
      resultTpye: true,
      isGifts: false,
      loading: false,
      TotalCount: 0,
      pi: 1,
      ps: 60,
      isOrder: false,
      isSwitch: false
    }
  },
  props: {
    userInfo: {}
  },
  watch: {
    '$store.state.isSwitch': {
      deep: true,
      handler(obj) {
        //console.log(obj, 'isSwitch')
        this.isSwitch = obj
      }
    }
  },
  created() {
    //this.getActivitySwitch()
    this.changeGifts(false)
  },
  mounted() {},
  methods: {
    getActivitySwitch() {
      let that = this
      let AreaCode = that.userInfo ? that.userInfo.MemberSource : that.$store.state.activityAreaCode
      let data = { areaCode: AreaCode }
      that.$get(that.$interface.GetActivitySwitch, data).then(res => {
        if (res.Result) {
          that.isOrder = that.$route.params.id ? true : false
          if (res.Data) {
            that.isSwitch = false
            if (res.Data.Show) {
              that.isSwitch = true
              that.changeGifts(that.isOrder)
            }
          }
        } else {}
      })
    },
    goto(obj) {
      let that = this
      let id = that.userInfo ? that.userInfo.MappingUserId : ''
      let AreaCode = that.userInfo ? that.userInfo.MemberSource : that.$store.state.activityAreaCode
      var url=obj.H5Url+'/' + obj.ActivityType+'?Id='+id+'&AreaCode='+AreaCode
      window.location.href=url
      // that.$router.push({
      //   path: obj.H5Url + obj.ActivityType,
      //   query: { Id: id, AreaCode: AreaCode }
      // })
    },
    CopyLink(val) {
      let that = this
      that.$copyText(val).then(function(e) {
        that.$message.success(that.$t('base.copysuc'));
        //that.isCopy = true
      }, function(e) {
        that.$message.error(that.$t('base.copyerr'));
        //that.isCopy = false
      })
    },
    changeGifts(bol) {
      let that = this;
      that.pi = 1
      that.activityList = null
      that.orderList = null
      that.isGifts = bol
      if (bol) {
        if (that.userInfo) {
          that.getGiftsList()
        } else {
          that.$router.push({
            path: '/login'
          })
        }
      } else {
        that.getActivityList()
      }
    },
    setAreaData() {
      let AreaData = this.$enumInfo.AreaData
      var navlanguage = window.navigator.language
      var data='US'
      AreaData.map(res => {
        if (res.browserLanguages == navlanguage) {
          data=res.areaCode
        }
      })
      return data
    },
    // 获取活动列表
    getActivityList() {
      let that = this;
      this.loading = true;
      let AreaCode = that.userInfo ? that.userInfo.MemberSource : that.setAreaData()
      let data = { PageIndex: that.pi, PageSize: that.ps, AreaCode: AreaCode }
      that.$post(that.$interface.GetActivityList, data).then(res => {
        if (res.Result != 0) {
          that.activityList = res.Data
          if (res.Count > 0) {
            that.TotalCount = res.Count
            that.resultTpye = false
          } else {
            that.resultTpye = true
          }
        } else {
          that.resultTpye = true
        }
        that.loading = false;
      }).catch(err => {
        that.resultTpye = true
        that.loading = false;
      })
    },
    // 获取订单列表
    getGiftsList() {
      let that = this;
      that.loading = true;

      let data = { MemberId: that.userInfo.MappingUserId, PageIndex: that.pi, PageSize: that.ps, AreaCode: that.userInfo.MemberSource }
      that.$get(that.$interface.GetActivityOrderList, data).then(res => {
        if (res.Result != 0) {
          that.orderList = res.Data
          if (res.Count > 0) {
            that.TotalCount = res.Count
            that.resultTpye = false
          } else {
            that.resultTpye = true
          }
        } else {
          that.resultTpye = true
        }
        that.loading = false;
      }).catch(err => {
        that.resultTpye = true
        that.loading = false;
      })
    },
    // 每页几条
    pageSize(val) {
      let that = this;
      that.ps = val
      if (that.isGifts) {
        that.getGiftsList()
      } else {
        that.getActivityList()
      }
    },
    // 页码
    pageIndex(val) {
      let that = this;
      this.pi = val
      if (that.isGifts) {
        that.getGiftsList()
      } else {
        that.getActivityList()
      }
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";

.thousand_layout {
  width: auto;
  min-width: 900px;
}

.noData {
  background: url(../../../static/images/noActivity.jpg) center no-repeat;
  width: 100%;
  height: 400px;
  margin-top: 20px;
  background-size: 144px 146px;
}

.searchList {
  display: grid;
  grid-template-columns: repeat(3, 304px);
  gap: 24px;
  margin: 16px 0 28px;
}

.slide_box {
  cursor: pointer;
}

.like_box {
  padding: 8px;
  overflow: hidden;
}

.like_box.sold {
  position: relative;
}

.like_box.sold .finished,
.like_box.sold .comingSoon {
  position: absolute;
  background: url(../../../static/images/activityFinished.png) no-repeat;
  width: 112px;
  height: 80px;
  z-index: 6;
  background-size: contain;
  left: 30%;
  top: 28%;
}

.like_box.sold .comingSoon {
  background-image: url(../../../static/images/activityComingSoon.png);
}

.like_box.sold:before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .25);
  left: 0;
  top: 0;
  z-index: 5;
}

.like_img {
  width: 100%;
  height: 182px;
  border-radius: 4px;
}

.slide_text {
  padding: 8px;
  height: 53px;
  overflow: hidden;
  line-height: 1.5;
}

.gifts {
  cursor: pointer;
  background: url(../../../static/images/article.jpg) 0 50% no-repeat;
  background-size: auto 90%;
  line-height: 30px;
  font-size: 18px;
  color: #5F6DAE;
  padding-left: 31px;
}

.flex_input {
  display: flex;
}

.flex_input button {
  color: #fff;
}

.base {
  color: #5F6DAE;
  border-color: #5F6DAE;
}

/deep/ .el-button span {
  display: flex;
  align-items: center;
}

/deep/ .el-button span:before {
  content: '';
  display: inline-block;
  margin-right: 5px;
  width: 13px;
  height: 13px;
  background: url(../../../static/images/btn_add.png) no-repeat;
  background-size: contain;
}

/deep/ .base span:before {
  background-image: url(../../../static/images/btn_arrow_left.png);
}

/deep/ .submit span:before {
  width: 0px;
  height: 0px;
  margin: 0;
}

.giftList {
  padding: 4px;
  margin-top: 15px;
}

.giftList li {
  display: flex;
  padding: 4px;
  border: 1px solid #f7f7f7;
  margin-bottom: 8px;
}

.giftList .like_box {
  padding: 0;
  margin-right: 8px;
  height: 88px;
}

.giftList .like_img {
  width: 88px;
  height: 88px;
  background: #f7f7f7;
}

.giftList .giftDetail {
  width: 700px;
}

.giftList .operate {
  display: flex;
  align-items: center;
  width: 128px;
  justify-content: flex-end;
}

.giftCode p {
  line-height: 2;
  display: flex;
  align-items: center;
}

.giftCode p span {
  width: 12px;
  height: 12px;
  background: url(../../../static/images/copy.jpg) no-repeat;
  background-size: contain;
  margin-left: 8px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/activity.vue